<template>

    <div class="dash-content-outer col">

        <div class="head">
            <h5 class="txt-grt">Monetization</h5>
            <div class="actns">
                <div class="btn main txt-blk" @click.prevent="$parent.openPlanOverlay">
                    <span class="hvr"></span>
                    <span class="ico">
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM11.5 11.5V6.5H14.5V11.5H19.5V14.5H14.5V19.5H11.5V14.5H6.5V11.5H11.5Z" fill="black"/>
                        </svg>
                    </span>
                    <span class="txt">New Subscription plan</span>
                </div>
            </div>
        </div>

        <div class="inner-content">

            <div class="all-plans">

                <!-- default free -->
                <div class="plan-preview col" :class="['radius' + Global.mockupConfig.radiusRatio, Global.mockupConfig.activeFont]">
                    <div class="preview col">
                        <h5 :style="{ color : Global.mockupConfig.colors.icons }">Free</h5>
                        <p class="ft-bld txt-ctr">Free content, advertising to<br> support us</p>
                        <ul>
                            <li>
                                <span class="ico" :style="{ background : Global.mockupConfig.colors.icons }">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <rect y="10.6067" width="3" height="10" transform="rotate(-45 0 10.6067)" fill="black"/>
                                    <rect width="3" height="15" transform="matrix(0.707103 0.70711 -0.707103 0.70711 15.5562 4.94971)" fill="black"/>
                                    </svg>
                                </span>
                                <span class="txt">Free content</span>
                            </li>
                            <li>
                                <span class="ico x">
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                                    <rect width="3" height="15" transform="matrix(0.707103 0.70711 -0.707103 0.70711 15.249 4.63589)" fill="white"/>
                                    <rect width="3" height="15" transform="matrix(0.707107 -0.707107 0.707114 0.7071 4.64258 6.75729)" fill="white"/>
                                    </svg>
                                </span>
                                <span class="txt">Premium contents</span>
                            </li>
                            <li>
                                <span class="ico x">
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                                    <rect width="3" height="15" transform="matrix(0.707103 0.70711 -0.707103 0.70711 15.249 4.63589)" fill="white"/>
                                    <rect width="3" height="15" transform="matrix(0.707107 -0.707107 0.707114 0.7071 4.64258 6.75729)" fill="white"/>
                                    </svg>
                                </span>
                                <span class="txt">Downloads for offline watch</span>
                            </li>
                        </ul>
                        <div class="btn main" :style="{ background : Global.mockupConfig.colors.icons }">
                            <span class="txt">Get free account</span>
                        </div>
                    </div>
                </div>

                <PlanCard :plan="Global.plans[1]" v-if="Global.plans[1]"></PlanCard>

            </div>
            
        </div>

    </div>

</template>

<script>

    import Global from '../../lib/GlobalState'
    import PlanCard from '../../components/PlanCard'

    export default {

        name: 'Monetization',

        components: {
            PlanCard
        },

        data() {
            return {
                Global
            }
        },

        methods: {

            // openPlanOverlay() {
            //     this.Global.tempClosingOverlay = false
            //     this.Global.activeBlurredOverlay = true
            //     this.Global.activePlanOverlay = true
            // },
            
        }
    }

</script>